angular.module('qkr')
    .directive('skipToContentHeader',[ function() {
        return {
            restrict: 'E',
            scope: {
                targetSelector: '@',
                linkText: '@',
            },
            template: '<header tabindex="-1">\n' +
                      '  <div id="skip-to-content-link">\n' +
                      '    <a href="javascript: void(0);">Skip to main content</a>' +
                      '  </div>' +
                      '</header>',
            link: function(scope, element, attrs){


                function init(){

                    const a = $('#skip-to-content-link > a', element);
                    if(a){
                        $( a ).on( "click", function() {
                            const target = document.querySelector( scope.targetSelector);
                            if(target){
                                target.focus();
                            }else{
                               a.blur();
                            }
                        } );
                    }
                }

                scope.targetSelector = scope.targetSelector || '.skip-to-content-target';
                scope.linkText = scope.linkText || 'Skip to main content';

                init();
            }
        }
    }
]);







// ({
//         restrict: 'E',
//         template: require('../templates/common/skipToContentHeader.html'),
//         link: ($scope) => {
//
//             init = function(){
//
//             }
//
//             init();
//         }
//     })
// );



// WEBPACK FOOTER //
// ./src/directives/skipToContentheader.js